import { FC } from "react";

/** Пучок четверть-колец, приякоренный к углу панели (центр — в точке 0;0). */
const CornerRings: FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 400 400" fill="none" className={className} aria-hidden>
    <g fill="none" strokeLinecap="round">
      <circle cx="0" cy="0" r="104" stroke="rgba(242,239,232,0.1)" strokeWidth="1.7" />
      <circle cx="0" cy="0" r="172" stroke="rgba(242,239,232,0.08)" strokeWidth="1.7" />
      <circle
        cx="0"
        cy="0"
        r="244"
        stroke="rgba(208,237,28,0.2)"
        strokeWidth="2"
        strokeDasharray="1 12"
      />
      <circle cx="0" cy="0" r="316" stroke="rgba(242,239,232,0.06)" strokeWidth="1.7" />
      <circle cx="0" cy="0" r="388" stroke="rgba(242,239,232,0.045)" strokeWidth="1.7" />
    </g>
  </svg>
);

/**
 * Фон тёмной панели: те же кольца, что и в hero, — 404 остаётся частью
 * сайта, а не отдельной заглушкой.
 */
export const PanelPattern: FC = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    <CornerRings className="absolute -left-4 -top-4 h-[280px] w-[280px] md:h-[420px] md:w-[420px]" />
    <CornerRings className="absolute -bottom-4 -right-4 h-[260px] w-[260px] rotate-180 md:h-[400px] md:w-[400px]" />
  </div>
);
